import { ReasonOrEntityLabelType } from 'v2/core/entities/feedback/labels';
import { AudioHighlightMetadata } from '../types';
import { FeedbackLabel, FeedbackLabelType } from 'v2/core/entities/feedback';

export const getLabelFromHighlight = (
  feedbackLabels: FeedbackLabel[],
  highlight?: AudioHighlightMetadata,
): ReasonOrEntityLabelType | undefined => {
  const label = feedbackLabels.find(
    (label): label is ReasonOrEntityLabelType =>
      label.id === highlight?.labelID &&
      (label.type === FeedbackLabelType.Entity ||
        label.type === FeedbackLabelType.Reason),
  );

  return label;
};
